import React from 'react';
import Grid from '@mui/material/Grid2';
import { Chip, Typography } from '@mui/material';
import { displayMessageDate } from 'utils/helpers';
import { ChatUsersCustomizationOption } from 'types/company-platforms/customizationSettings';

interface UserDateAndUnreadProps {
  selected?: boolean;
  unreadMessagesNumber: number;
  lastMessageDate: string;
  hoverStyles: ChatUsersCustomizationOption | null;
  selectedStyles: ChatUsersCustomizationOption | null;
  unreadStyles: ChatUsersCustomizationOption | null;
  defaultStyles: ChatUsersCustomizationOption | null;
}

const UserDateAndUnread: React.FC<UserDateAndUnreadProps> = ({
  selected,
  unreadMessagesNumber,
  lastMessageDate,
  hoverStyles,
  selectedStyles,
  unreadStyles,
  defaultStyles,
}) => {
  return (
    <Grid container spacing={2} alignItems={'center'} justifyContent={'flex-end'} flexWrap={'nowrap'}>
      <Grid size="auto">
        <Typography
          variant={'body2'}
          sx={{
            '.MuiListItemButton-root:not(.Mui-selected):hover &': {
              color:
                hoverStyles?.value === 'custom'
                  ? hoverStyles.customColor.date + ' !important'
                  : // : 'rgba(0, 0, 0, 0.87) !important',
                    undefined,
            },
            color: selected
              ? selectedStyles?.value === 'custom'
                ? selectedStyles.customColor.date + ' !important'
                : undefined
              : unreadMessagesNumber > 0
                ? unreadStyles?.value === 'custom'
                  ? unreadStyles.customColor.date + ' !important'
                  : undefined
                : defaultStyles?.value === 'custom'
                  ? defaultStyles.customColor.date + ' !important'
                  : undefined,

            WebkitTransition: 'color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            transition: 'color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            fontSize: 13,
          }}
        >
          {lastMessageDate &&
            (displayMessageDate(lastMessageDate) === 0 ? (
              String(lastMessageDate).slice(11, 16)
            ) : (
              <>
                {`${String(lastMessageDate).slice(8, 10)}/${String(lastMessageDate).slice(
                  5,
                  7,
                )}/${String(lastMessageDate).slice(0, 4)}`}
              </>
            ))}
        </Typography>
      </Grid>
      {unreadMessagesNumber > 0 && (
        <Grid
          size="auto"
          sx={{
            my: -1.25,
          }}
        >
          <Chip
            size="small"
            color="info"
            label={unreadMessagesNumber}
            sx={{
              bgcolor:
                unreadStyles?.value === 'custom'
                  ? unreadStyles.customColor.unreadIndicatorBackground + ' !important'
                  : undefined,
              color:
                unreadStyles?.value === 'custom'
                  ? unreadStyles.customColor.unreadIndicatorText + ' !important'
                  : undefined,
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};
export default UserDateAndUnread;
